import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_internal_sales_invoice_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    doc_no: fromDatatype.VarcharDatatypeInterface;
    branch_code: fromDatatype.VarcharDatatypeInterface;
    location_code: fromDatatype.VarcharDatatypeInterface;
    purchaser: fromDatatype.VarcharDatatypeInterface;
    txn_date: fromDatatype.TimestampTzDatatypeInterface;
    hdr_ref_no: fromDatatype.VarcharDatatypeInterface;
    credit_terms: fromDatatype.VarcharDatatypeInterface;
    hdr_remarks: fromDatatype.TextDatatypeInterface;
    crm_contact: fromDatatype.VarcharDatatypeInterface;
    member_card_no: fromDatatype.VarcharDatatypeInterface;
    doc_currency: fromDatatype.VarcharDatatypeInterface;
    sales_lead: fromDatatype.VarcharDatatypeInterface;
    tracking_id: fromDatatype.VarcharDatatypeInterface;
    entity_code: fromDatatype.VarcharDatatypeInterface;
    billing_name: fromDatatype.VarcharDatatypeInterface;
    billing_email: fromDatatype.VarcharDatatypeInterface;
    billing_phone: fromDatatype.VarcharDatatypeInterface;
    billing_address_line_1: fromDatatype.TextDatatypeInterface;
    billing_address_line_2: fromDatatype.TextDatatypeInterface;
    billing_address_line_3: fromDatatype.TextDatatypeInterface;
    billing_address_line_4: fromDatatype.TextDatatypeInterface;
    billing_address_line_5: fromDatatype.TextDatatypeInterface;
    billing_country: fromDatatype.VarcharDatatypeInterface;
    billing_state: fromDatatype.VarcharDatatypeInterface;
    billing_city: fromDatatype.VarcharDatatypeInterface;
    billing_postcode: fromDatatype.VarcharDatatypeInterface;
    shipping_name: fromDatatype.VarcharDatatypeInterface;
    shipping_email: fromDatatype.VarcharDatatypeInterface;
    shipping_phone: fromDatatype.VarcharDatatypeInterface;
    shipping_address_line_1: fromDatatype.TextDatatypeInterface;
    shipping_address_line_2: fromDatatype.TextDatatypeInterface;
    shipping_address_line_3: fromDatatype.TextDatatypeInterface;
    shipping_address_line_4: fromDatatype.TextDatatypeInterface;
    shipping_address_line_5: fromDatatype.TextDatatypeInterface;
    shipping_country: fromDatatype.VarcharDatatypeInterface;
    shipping_state: fromDatatype.VarcharDatatypeInterface;
    shipping_city: fromDatatype.VarcharDatatypeInterface;
    shipping_postcode: fromDatatype.VarcharDatatypeInterface;
    settlement_or_item_code: fromDatatype.VarcharDatatypeInterface;
    settlement_or_item_name: fromDatatype.TextDatatypeInterface;
    item_ref_no: fromDatatype.TextDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    stl_amount: fromDatatype.NumericDatatypeInterface;
    voucher_no: fromDatatype.VarcharDatatypeInterface;
    card_no: fromDatatype.VarcharDatatypeInterface;
    transaction_no: fromDatatype.VarcharDatatypeInterface;
    stl_remarks: fromDatatype.TextDatatypeInterface;
    qty: fromDatatype.NumericDatatypeInterface;
    uom: fromDatatype.VarcharDatatypeInterface;
    unit_price: fromDatatype.NumericDatatypeInterface;
    amount: fromDatatype.NumericDatatypeInterface;
    discount_amount: fromDatatype.NumericDatatypeInterface;
    tax_code: fromDatatype.VarcharDatatypeInterface;
    tax_amount: fromDatatype.NumericDatatypeInterface;
    item_serial_no: fromDatatype.JsonDatatypeInterface;
    item_batch_no: fromDatatype.JsonDatatypeInterface;
    item_tracking_id: fromDatatype.VarcharDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    validated: boolean;
    processed: boolean;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_internal_sales_invoice_import_file_helper_RowClass implements bl_fi_internal_sales_invoice_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    doc_no: fromDatatype.VarcharDatatypeInterface;
    branch_code: fromDatatype.VarcharDatatypeInterface;
    location_code: fromDatatype.VarcharDatatypeInterface;
    purchaser: fromDatatype.VarcharDatatypeInterface;
    txn_date: fromDatatype.TimestampTzDatatypeInterface;
    hdr_ref_no: fromDatatype.VarcharDatatypeInterface;
    credit_terms: fromDatatype.VarcharDatatypeInterface;
    hdr_remarks: fromDatatype.TextDatatypeInterface;
    crm_contact: fromDatatype.VarcharDatatypeInterface;
    member_card_no: fromDatatype.VarcharDatatypeInterface;
    doc_currency: fromDatatype.VarcharDatatypeInterface;
    sales_lead: fromDatatype.VarcharDatatypeInterface;
    tracking_id: fromDatatype.VarcharDatatypeInterface;
    entity_code: fromDatatype.VarcharDatatypeInterface;
    billing_name: fromDatatype.VarcharDatatypeInterface;
    billing_email: fromDatatype.VarcharDatatypeInterface;
    billing_phone: fromDatatype.VarcharDatatypeInterface;
    billing_address_line_1: fromDatatype.TextDatatypeInterface;
    billing_address_line_2: fromDatatype.TextDatatypeInterface;
    billing_address_line_3: fromDatatype.TextDatatypeInterface;
    billing_address_line_4: fromDatatype.TextDatatypeInterface;
    billing_address_line_5: fromDatatype.TextDatatypeInterface;
    billing_country: fromDatatype.VarcharDatatypeInterface;
    billing_state: fromDatatype.VarcharDatatypeInterface;
    billing_city: fromDatatype.VarcharDatatypeInterface;
    billing_postcode: fromDatatype.VarcharDatatypeInterface;
    shipping_name: fromDatatype.VarcharDatatypeInterface;
    shipping_email: fromDatatype.VarcharDatatypeInterface;
    shipping_phone: fromDatatype.VarcharDatatypeInterface;
    shipping_address_line_1: fromDatatype.TextDatatypeInterface;
    shipping_address_line_2: fromDatatype.TextDatatypeInterface;
    shipping_address_line_3: fromDatatype.TextDatatypeInterface;
    shipping_address_line_4: fromDatatype.TextDatatypeInterface;
    shipping_address_line_5: fromDatatype.TextDatatypeInterface;
    shipping_country: fromDatatype.VarcharDatatypeInterface;
    shipping_state: fromDatatype.VarcharDatatypeInterface;
    shipping_city: fromDatatype.VarcharDatatypeInterface;
    shipping_postcode: fromDatatype.VarcharDatatypeInterface;
    settlement_or_item_code: fromDatatype.VarcharDatatypeInterface;
    settlement_or_item_name: fromDatatype.TextDatatypeInterface;
    item_ref_no: fromDatatype.TextDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    stl_amount: fromDatatype.NumericDatatypeInterface;
    voucher_no: fromDatatype.VarcharDatatypeInterface;
    card_no: fromDatatype.VarcharDatatypeInterface;
    transaction_no: fromDatatype.VarcharDatatypeInterface;
    stl_remarks: fromDatatype.TextDatatypeInterface;
    qty: fromDatatype.NumericDatatypeInterface;
    uom: fromDatatype.VarcharDatatypeInterface;
    unit_price: fromDatatype.NumericDatatypeInterface;
    amount: fromDatatype.NumericDatatypeInterface;
    discount_amount: fromDatatype.NumericDatatypeInterface;
    tax_code: fromDatatype.VarcharDatatypeInterface;
    tax_amount: fromDatatype.NumericDatatypeInterface;
    item_serial_no: fromDatatype.JsonDatatypeInterface;
    item_batch_no: fromDatatype.JsonDatatypeInterface;
    item_tracking_id: fromDatatype.VarcharDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    validated: boolean;
    processed: boolean;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}